export const news = {
  newsFeedCreateInputPlaceholder: 'Napsat příspěvek...',
  newsFeedSearchInputPlaceholder: 'Hledat',
  newsFeedPostOwnerCurtainEditTitle: 'Upravit příspěvek',
  newsFeedPostOwnerCurtainDeleteTitle: 'Smazat příspěvek',
  newsFeedEditedPostSavedAlertText: 'Příspěvek uložen!',
  newsFeedEditedPostDeletedAlertText: 'Příspěvek smazán!',
  newsFeedShareCurtainOptionTitle: 'Kopírovat odkaz',
  newsFeedPostLinkCopiedAlertText: 'Odkaz zkopírován!',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Kopírovat odkaz',
  newsFeedOthersPosLinkCopiedAlertText: 'Odkaz zkopírován!',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Nahlásit obsah',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Smazat příspěvek',
  newsFeedPostDeletePopupTitle: 'Smazat',
  newsFeedPostDeletePopupText: 'Smazat tento příspěvek?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Zrušit',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Potvrdit',
  newsFeedPostDeeletedAlertText: 'Příspěvek smazán!',
  newsPostDetailsHeaderTitle: 'Příspěvek',
  postFeedPostLikesText: 'Líbí se',
  postFeedPostCommentsText: 'Komentáře',
  postFeedPostNoLikesText: 'Zatím zde nejsou žádná líbí se',
  postFeedPostLeaveFirstLikeText: 'Můžete být první, kdo se líbí',
  newsFeedPostDetailsNoCommentsText: 'Zatím zde nejsou žádné komentáře\nMůžete být první, kdo něco napíše',
  newsFeedPostDetailsFirstCommentText: 'Můžete být první, kdo něco napíše',
  newsFeedPostDetailsShareOptionTitle: 'Kopírovat odkaz',
  newsFeedPostDetailsSharePostCopiedAlertText: 'Odkaz zkopírován!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Kopírovat odkaz',
  newsFeedPostDetailsCopiedAlertText: 'Odkaz zkopírován!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Nahlásit obsah',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Nahlásit',
  newsPostDetailsReportedCurtainText: 'Obsah nahlášen',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Upravit komentář',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Smazat komentář',
  newsPostDetailsEditedCommentSavedAlertText: 'Komentář uložen!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Smazat komentář',
  postDetailsOtherUsersCommentDeletadAlertText: 'Komentář smazán!',
  postDetailsDeleteCommentPopupTitle: 'Smazat',
  postDetailsDeleteCommentPopupText: 'Smazat tento komentář?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Zrušit',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Potvrdit',
  postDetailsCommDeletedAlertText: 'Komentář smazán!',
  postDetailsCommentUserCurtainOptionTitle: 'Nahlásit komentář',
  newsCreatePostCurtainTitle: 'Nový příspěvek',
  newsCreatePostCurtainBodyPlaceholder: 'Sem vložte text...',
  newsCreatePostPublishButtonTitle: 'Publikovat',
  newsCreatePostUploadSlallerImageAlertText: 'Nelze nahrát více než {size} MB najednou',
  newsPostSavedAlertText: 'Příspěvek uložen!',
  newsCreatePostAddLocationCurtainTitle: 'Umístění',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Název umístění',
  newsCreatePostEditLocationCurtainText: 'Upravit umístění',
  newsDeleteLocation: 'Smazat umístění',
  newsDiscardPostPopupTitle: 'Koncept',
  newsDiscardPostPopupText: 'Zahodit tento koncept?',
  newsDiscardPostPopupCancelButtonTitle: 'Zrušit',
  newsDiscardPostPopupCofirmButtonTitle: 'Potvrdit',
  newsNewPostCreatePollTitle: 'Vytvořit anketu',
  newsNewPostCreatePollTitleInputPlaceholder: 'Název',
  newsNewPostCreatePollOptionInputPlaceholder: 'Možnost',
  newsNewPostCreatePollAddButtonTitle: 'Přidat možnost',
  newsNewPostCreatePollCreateButtonTitle: 'Vytvořit',
  newsCreatePostPollTitleBlankAlertText: 'Název nesmí být prázdný!',
  newsCreatePostPollOptionBlankAlertText: 'Možnost nesmí být prázdná!',
  newsCreatePostPollLongTitleAlertText: 'Název musí obsahovat maximálně {length} znaků',
  newsCreatePostPollLongOptionAlertText: 'Možnost musí obsahovat maximálně {length} znaků',
  newsCreatePostPollEditOptionTitle: 'Upravit anketu',
  newsCreatePostPollRemoveOptionTitle: 'Odebrat anketu',
  newsPostPollInfoVotesText: 'hlasů',
  newsPostPollInfoEditVoteText: 'Upravit hlas',
  newsPostPollFinishPollText: 'Ukončit anketu',
  newsPostPollFinishedPollText: 'Ukončeno',
  newsPostPollInProgresslText: 'V průběhu',
  newsFinishPollCurtainTitle: 'Ukončit anketu',
  newsFinishPollCurtainText: 'Uživatelé po ukončení ankety nebudou moci hlasovat.',
  newsFinishPollCurtainCancelButtonTitle: 'Zrušit',
  newsFinishPollCurtainConfirmlButtonTitle: 'Potvrdit',
  newsPollInfoPollVotesCurtainTitle: 'Hlasy v anketě',
  newsEditPostCurtainTitle: 'Upravit příspěvek',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Sem vložte text...',
  newsEditPostCurtainSaveButtonTitle: 'Uložit',
  newsEditPostSavedAlertText: 'Příspěvek uložen!',
  newsError: 'Něco se pokazilo!',
  newsAt: 'v',
  newsSeeMore: 'Zobrazit více...',
  newsMaxAttachments: 'Překročili jste maximální počet příloh. Maximální počet příloh je {length}',
  newsReply: 'Odpovědět',
  newsPin: 'Připnout příspěvek',
  newsUnpin: 'Odepnout příspěvek'
}
